/**
 * The admin panel blue. Kept local to this page rather than imported from a
 * sibling layout so the two can be restyled independently.
 */
export const BLUE = {
  main: '#1A73E8',
  dark: '#0D47A1',
  soft: '#E8F0FE',
  line: '#C6DAFC',
  mutedBg: '#F1F3F4',
  mutedText: '#5F6368',
}

/** Turns any MUI Switch blue without touching the global theme. */
export const blueSwitchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: BLUE.main },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: BLUE.main,
    opacity: 0.5,
  },
}

/**
 * The chat header gives the name a single line beside the status pill. The API
 * enforces the same ceiling — this copy just stops the admin typing past it.
 */
export const NAME_MAX = 40

export const AUDIENCES = [
  { value: 'both', label: 'Everyone' },
  { value: 'host', label: 'Hosts' },
  { value: 'creative', label: 'Creatives' },
]

/** What a chip does when it is clicked. Mirrors the API's ActionTypes enum. */
export const ACTION_TYPES = [
  { value: 'prompt', label: 'Ask the bot' },
  { value: 'link', label: 'Open a page' },
]

export const labelFor = (list, value) =>
  list.find((item) => item.value === value)?.label || value

const emptyButton = {
  label: '',
  audience: 'both',
  actionType: 'prompt',
  // Only one of these is used, decided by actionType.
  prompt: '',
  link: '',
  newTab: false,
  isActive: true,
}

/** A blank row for the add form. */
export const newButton = () => ({ ...emptyButton })

/** Fills in anything the API left off so the form never binds to undefined. */
export const toButtonForm = (button) => ({ ...emptyButton, ...(button || {}) })

/**
 * What the website will actually render for this row — the same rule the API
 * applies, mirrored here so the panel can warn before saving instead of the
 * chip silently vanishing from the chat.
 */
export const isRenderable = (button) => {
  if (!button?.isActive || !String(button.label || '').trim()) return false

  return button.actionType === 'link'
    ? Boolean(String(button.link || '').trim())
    : Boolean(String(button.prompt || '').trim())
}

/** Moves a row up or down by one, returning a new array. */
export const moveItem = (list, index, offset) => {
  const target = index + offset
  if (target < 0 || target >= list.length) return list

  const next = [...list]
  const [row] = next.splice(index, 1)
  next.splice(target, 0, row)

  return next
}
